export function getFileInputValue({ current }) {
  if (current && current.files.length) {
    return current.files[0];
  }
  return null;
}
